(() => {
  const $ = (s,r=document) => r.querySelector(s);
  const $$ = (s,r=document) => [...r.querySelectorAll(s)];
  const mobileQuery=window.matchMedia('(max-width: 760px)');
  function slidesOf(gallery){return gallery?$$('.pdp-slide',gallery):[];}
  function currentSlide(gallery){const track=gallery&&$('[data-yoko-slides]',gallery);if(!track||!track.clientWidth)return 0;return Math.round(track.scrollLeft/track.clientWidth);}
  function goToSlide(gallery,index){
    const track=gallery&&$('[data-yoko-slides]',gallery),slides=slidesOf(gallery);if(!track||!slides.length)return;
    const i=Math.max(0,Math.min(slides.length-1,index));
    track.scrollTo({left:i*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    markSlide(gallery,i);
  }
  function markSlide(gallery,i){
    $$('.yoko-product-thumbnails button',gallery).forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
    $$('.pdp-dots span',gallery).forEach((d,n)=>d.classList.toggle('is-active',n===i));
    const count=slidesOf(gallery).length,prev=$('.pdp-slide-arrow.is-prev',gallery),next=$('.pdp-slide-arrow.is-next',gallery);
    if(prev)prev.disabled=i<=0;if(next)next.disabled=i>=count-1;
  }
  function setupGallery(gallery){
    if(gallery.dataset.ready)return;gallery.dataset.ready='true';
    const track=$('[data-yoko-slides]',gallery);if(!track)return;
    let frame=0;
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>markSlide(gallery,currentSlide(gallery)));},{passive:true});
    track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();goToSlide(gallery,currentSlide(gallery)+1);}if(e.key==='ArrowLeft'){e.preventDefault();goToSlide(gallery,currentSlide(gallery)-1);}});
    // Mouse drag on desktop; touch devices use native swipe with scroll snap.
    let startX=0,startLeft=0,down=false;
    track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;down=true;startX=e.clientX;startLeft=track.scrollLeft;track.dataset.dragged='false';});
    track.addEventListener('pointermove',e=>{if(!down)return;const dx=e.clientX-startX;if(Math.abs(dx)>6){track.dataset.dragged='true';track.classList.add('is-dragging');}if(track.dataset.dragged==='true')track.scrollLeft=startLeft-dx;});
    const end=e=>{if(!down)return;down=false;track.classList.remove('is-dragging');if(track.dataset.dragged==='true'){const dx=e.clientX-startX;const base=Math.round(startLeft/track.clientWidth);goToSlide(gallery,base+(dx<-40?1:dx>40?-1:0));setTimeout(()=>{track.dataset.dragged='false';},50);}};
    track.addEventListener('pointerup',end);track.addEventListener('pointerleave',end);
    track.addEventListener('dragstart',e=>e.preventDefault());
    markSlide(gallery,0);
  }
  function syncSizes(root){
    const select=root&&$('[data-yoko-variant]',root);if(!select)return;
    $$('[data-yoko-size]',root).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.yokoSize===select.value)));
  }
  document.addEventListener('click',async e=>{
    if(e.target.closest('[data-yoko-cookie]')){
      e.preventDefault();
      if(window.CCM?.openWidget)window.CCM.openWidget();
      return;
    }
    const thumb=e.target.closest('[data-yoko-gallery-image]');
    if(thumb){
      const gallery=thumb.closest('[data-yoko-gallery]');
      goToSlide(gallery,$$('.yoko-product-thumbnails button',gallery).indexOf(thumb));
      return;
    }
    const step=e.target.closest('[data-yoko-slide]');
    if(step){const gallery=step.closest('[data-yoko-gallery]');goToSlide(gallery,currentSlide(gallery)+Number(step.dataset.yokoSlide));return;}
    const size=e.target.closest('[data-yoko-size]');
    if(size){
      const root=size.closest('[data-yoko-product]'),select=$('[data-yoko-variant]',root);
      if(select&&select.value!==size.dataset.yokoSize){select.value=size.dataset.yokoSize;select.dispatchEvent(new Event('change',{bubbles:true}));}
      return;
    }
    const open=e.target.closest('[data-yoko-open]');
    if(open){
      if(open.dataset.yokoZoom){
        if(mobileQuery.matches){e.preventDefault();return;}
        const slides=open.closest('[data-yoko-slides]');if(slides&&slides.dataset.dragged==='true'){e.preventDefault();return;}
      }
      const d=document.getElementById(open.dataset.yokoOpen);
      const img=d&&$('img',d);
      if(img&&open.dataset.yokoZoom){img.removeAttribute('srcset');img.src=open.dataset.yokoZoom;img.alt=open.dataset.alt||'';}
      d?.showModal();return;
    }
    const close=e.target.closest('[data-yoko-close]');
    if(close){close.closest('dialog')?.close();return;}
    const more=e.target.closest('[data-yoko-load-more]');
    if(more){
      e.preventDefault();if(more.dataset.busy)return;more.dataset.busy='true';
      try{
        const response=await fetch(more.href);
        if(!response.ok)throw Error('load');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const grid=$('[data-yoko-collection-grid]',doc),pagination=$('[data-yoko-pagination]',doc);
        if(!grid||!pagination)throw Error('missing');
        $('[data-yoko-collection-grid]').insertAdjacentHTML('beforeend',grid.innerHTML);
        $('[data-yoko-pagination]').innerHTML=pagination.innerHTML;
      }catch(_){location.href=more.href;}
    }
  });
  $$('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
  function setup(scope=document){
    $$('[data-yoko-gallery]',scope).forEach(setupGallery);
    $$('[data-yoko-product]',scope).forEach(syncSizes);
    $$('[data-yoko-feed]',scope).forEach(async el=>{
      if(el.dataset.loaded)return;el.dataset.loaded='true';
      try{const r=await fetch(el.dataset.yokoFeed);if(!r.ok)return;const d=new DOMParser().parseFromString(await r.text(),'text/html');const cards=$$('.product-card',d).slice(0,+el.dataset.limit);if(cards.length)$('[data-yoko-feed-grid]',el).replaceChildren(...cards);}catch(_){}
    });
    $$('[data-yoko-recommendations]',scope).forEach(async el=>{
      if(el.dataset.loaded)return;el.dataset.loaded='true';
      try{const r=await fetch(el.dataset.yokoRecommendations);if(!r.ok)return;const d=new DOMParser().parseFromString(await r.text(),'text/html');const cards=$$('.product-card',d);if(cards.length)$('[data-yoko-recommendations-grid]',el).replaceChildren(...cards);}catch(_){}
    });
    // Limit the fallback recommendation list to four products.
    $$('[data-yoko-recommendations-grid]',scope).forEach(el=>$$('.product-card',el).slice(4).forEach(c=>c.remove()));
  }
  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-yoko-variant]');if(!select)return;
    const option=select.selectedOptions[0],root=select.closest('[data-yoko-product]');
    const inStock=option.dataset.available==='true',button=$('[data-yoko-add]',root),stock=$('[data-yoko-stock]',root);
    $('[data-yoko-price]',root).textContent=option.dataset.price;
    button.disabled=!inStock;button.textContent=inStock?button.dataset.label:button.dataset.sold;
    stock.textContent=inStock?stock.dataset.in:stock.dataset.out;
    const checkout=$('.shopify-payment-button',root);if(checkout)checkout.hidden=!inStock;
    syncSizes(root);
    const u=new URL(location.href);u.searchParams.set('variant',option.value);history.replaceState({},'',u);
  });
  // Native product POST deliberately retained: Shopify performs cart validation,
  // selling-plan logic, cart redirect and native commerce tracking.
  document.addEventListener('shopify:section:load',e=>setup(e.target));
  setup();
})();
